module.exports = __webpack_public_path__ + "public/images/red-arrow.db209f608127dca073eced7cdd7c1d81.svg";